function CategoryCard({ category }) {
    return (
        <div className="px-1 flex flex-col items-center gap-1 shrink-0">
            <div className="size-11 rounded-full overflow-hidden">
                <img className='size-full object-cover' src={category.imageLink} alt={category.name} />
            </div>

            <p className='font-normal text-[8px] leading-[14px] text-[#000000]'>{category.name}</p>
        </div>
    );
}

function CategorySectionDesktop({ item }) {
    return (
        <div className='w-full flex flex-col gap-3'>
            <p className='px-4 font-semibold text-[12px] leading-[18px] text-[#000000]'>{item.item.name}</p>

            <div className="px-4 flex flex-nowrap gap-2 overflow-x-scroll no-scrollbar">
                {item.item.categoryLinkList.map(category => {
                    return (
                        <CategoryCard 
                            key={category.id} 
                            category={category} 
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default CategorySectionDesktop;
